var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretSolidDown = function SvgCaretSolidDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.445 9.146a.783.783 0 0 0 1.106 0l5.219-5.192a.773.773 0 0 0 0-1.1.785.785 0 0 0-1.106 0L6 7.494l-4.664-4.64a.783.783 0 0 0-1.106 0 .776.776 0 0 0 0 1.1l5.22 5.192z"
  })));
};
export default SvgCaretSolidDown;